import {
  guardGuestsFiltersDto,
  guestsFiltersDto,
  guestsManagementAddGuestDto,
} from './guestsManagementDto';
import { TFunction } from 'i18next';
import {
  GUESTS_MANAGEMENT_DELETE_FUTURE_GUEST,
  GUESTS_MANAGEMENT_DELETE_PAST_GUEST,
  GUESTS_MANAGEMENT_GET_ALL_FUTURE_GUESTS,
  GUESTS_MANAGEMENT_GET_ALL_GUARD_FUTURE_GUESTS,
  GUESTS_MANAGEMENT_GET_ALL_GUARD_PAST_GUESTS,
  GUESTS_MANAGEMENT_GET_ALL_PAST_GUESTS,
  GUESTS_MANAGEMENT_GUARD_SET_ACTIVE_PAGE,
  GUESTS_MANAGEMENT_GUARD_SET_ARRIVAL_DATE_FILTER,
  GUESTS_MANAGEMENT_GUARD_SET_BUILDING_FILTER,
  GUESTS_MANAGEMENT_GUARD_SET_COMPANY_NAME_FILTER,
  GUESTS_MANAGEMENT_GUARD_SET_COUNT_TO_SHOW,
  GUESTS_MANAGEMENT_GUARD_SET_FULL_NAME_FILTER,
  GUESTS_MANAGEMENT_GUARD_SET_LICENSE_NUMBER_FILTER,
  GUESTS_MANAGEMENT_GUARD_SET_PAGES,
  GUESTS_MANAGEMENT_GUARD_SET_PHONE_FILTER,
  GUESTS_MANAGEMENT_MY_GUESTS_SET_ACTIVE_PAGE,
  GUESTS_MANAGEMENT_MY_GUESTS_SET_ARRIVAL_DATE_FILTER,
  GUESTS_MANAGEMENT_MY_GUESTS_SET_COUNT_TO_SHOW,
  GUESTS_MANAGEMENT_MY_GUESTS_SET_FULL_NAME_FILTER,
  GUESTS_MANAGEMENT_MY_GUESTS_SET_PAGES,
  GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_ACTIVE_PAGE,
  GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_COUNT_TO_SHOW,
  GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_FULL_NAME_FILTER,
  GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_PAGES,
  GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_SELECTED_IDS,
  GUESTS_MANAGEMENT_SET_LICENSE_NUMBER_FILTER,
  GUESTS_MANAGEMENT_SET_PHONE_FILTER,
  GUESTS_MANAGEMENT_SET_REPEATABLE_GUESTS,
  guestsManagementGetAllFutureGuestsActionType,
  guestsManagementGetAllGuardFutureGuestsActionType,
  guestsManagementGetAllGuardPastGuestsActionType,
  guestsManagementGetAllPastGuestsActionType,
  guestsManagementGuardSetActivePageActionType,
  guestsManagementGuardSetArrivalDateFilterActionType,
  guestsManagementGuardSetBuildingFilterActionType,
  guestsManagementGuardSetCompanyNameFilterActionType,
  guestsManagementGuardSetCountToShowActionType,
  guestsManagementGuardSetFullNameFilterActionType,
  guestsManagementGuardSetLicenseNumberFilterActionType,
  guestsManagementGuardSetPagesActionType,
  guestsManagementGuardSetPhoneFilterActionType,
  guestsManagementMyGuestsSetActivePageActionType,
  guestsManagementMyGuestsSetArrivalDateFilterActionType,
  guestsManagementMyGuestsSetCountToShowActionType,
  guestsManagementMyGuestsSetFullNameFilterActionType,
  guestsManagementMyGuestsSetPagesActionType,
  guestsManagementRemoveFutureGuestActionType,
  guestsManagementRemovePastGuestActionType,
  guestsManagementRepeatableGuestsSetActivePageActionType,
  guestsManagementRepeatableGuestsSetCountToShowActionType,
  guestsManagementRepeatableGuestsSetFullNameFilterActionType,
  guestsManagementRepeatableGuestsSetSelectedIdsActionType,
  guestsManagementRepeatableGuestsSetPagesActionType,
  guestsManagementSetLicenseNumberFilterActionType,
  guestsManagementSetPhoneFilterActionType,
  guestsManagementSetRepeatableGuestsActionType,
  GuestsManagementThunk,
} from './guestsManagementActionTypes';
import GuestManagementApi from '../../API/guests/GuestManagement.api';
import { GUESTS_MANAGEMENT_NAMESPACE } from './guestsManagementReducer';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import {
  Guest,
  GuestManagementUpdateGuest,
  RepeatableGuest,
} from './guestsManagementTypes';
import { InviteVisitorFormValues } from '../../components/modals/InviteVisitorModal';
import { ResourceManagementThunk } from '../RoomManagement/resourceManagementActionTypes';
import { UpdateGuestRequestDto } from '../../API/guests/dto/request/edit-guest-request.dto';
import { CreateManyGuestsRequestDto } from '../../API/guest-management/dto/request/create-many-guests-request.dto';
import { GuestPlaceDto } from '../../API/guests/dto/request/guest-place.dto';
import { AddNewRepeatableGuestRequestDto } from '../../API/guests/dto/request/add-new-repeatable-guest.request.dto';
import { UpdateNewRepeatableGuestRequestDto } from '../../API/guests/dto/request/update-new-repeatable-guest.request.dto';

export function guestsManagementSetRepeatableGuestsAction(
  guests: RepeatableGuest[]
): guestsManagementSetRepeatableGuestsActionType {
  return {
    type: GUESTS_MANAGEMENT_SET_REPEATABLE_GUESTS,
    guests,
  };
}

export function guestsManagementRepeatableGuestsSetSelectedIdsAction(
  selectedIds: number[]
): guestsManagementRepeatableGuestsSetSelectedIdsActionType {
  return {
    type: GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_SELECTED_IDS,
    selectedIds,
  };
}

export function guestsManagementSetPhoneFilterAction(
  phone: string
): guestsManagementSetPhoneFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_SET_PHONE_FILTER,
    phone,
  };
}

export function guestsManagementGuardSetPhoneFilterAction(
  phone: string
): guestsManagementGuardSetPhoneFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_PHONE_FILTER,
    phone,
  };
}

export function guestsManagementRepeatableGuestsSetActivePageAction(
  page: number
): guestsManagementRepeatableGuestsSetActivePageActionType {
  return {
    type: GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_ACTIVE_PAGE,
    page,
  };
}

export function guestsManagementRepeatableGuestsSetCountToShowAction(
  count: number
): guestsManagementRepeatableGuestsSetCountToShowActionType {
  return {
    type: GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_COUNT_TO_SHOW,
    count,
  };
}

export function guestsManagementRepeatableGuestsSetPagesAction(
  pages: number
): guestsManagementRepeatableGuestsSetPagesActionType {
  return {
    type: GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_PAGES,
    pages,
  };
}

export function guestsManagementRepeatableGuestsSetFullNameFilterAction(
  fullName: string
): guestsManagementRepeatableGuestsSetFullNameFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_REPEATABLE_GUESTS_SET_FULL_NAME_FILTER,
    fullName,
  };
}

export function guestsManagementSetLicenseNumberFilterAction(
  licenseNumber: string
): guestsManagementSetLicenseNumberFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_SET_LICENSE_NUMBER_FILTER,
    licenseNumber,
  };
}

export function guestsManagementGuardSetActivePageAction(
  page: number
): guestsManagementGuardSetActivePageActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_ACTIVE_PAGE,
    page,
  };
}

export function guestsManagementGuardSetFullNameFilterAction(
  fullName: string
): guestsManagementGuardSetFullNameFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_FULL_NAME_FILTER,
    fullName,
  };
}

export function guestsManagementGuardSetLicenseNumberFilterAction(
  licenseNumber: string
): guestsManagementGuardSetLicenseNumberFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_LICENSE_NUMBER_FILTER,
    licenseNumber,
  };
}

export function guestsManagementMyGuestsSetFullNameFilterAction(
  fullName: string
): guestsManagementMyGuestsSetFullNameFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_MY_GUESTS_SET_FULL_NAME_FILTER,
    fullName,
  };
}

export function guestsManagementGuardSetCompanyNameFilterAction(companyId: {
  value: string;
  label: string;
}): guestsManagementGuardSetCompanyNameFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_COMPANY_NAME_FILTER,
    companyId,
  };
}

export function guestsManagementGuardSetBuildingFilterAction(buildingId: {
  value: string;
  label: string;
}): guestsManagementGuardSetBuildingFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_BUILDING_FILTER,
    buildingId,
  };
}

export function guestsManagementGuardSetArrivalDateFilterAction(
  arrivalDate: Date[]
): guestsManagementGuardSetArrivalDateFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_ARRIVAL_DATE_FILTER,
    arrivalDate,
  };
}

export function guestsManagementMyGuestsSetArrivalDateFilterAction(
  arrivalDate: Date[]
): guestsManagementMyGuestsSetArrivalDateFilterActionType {
  return {
    type: GUESTS_MANAGEMENT_MY_GUESTS_SET_ARRIVAL_DATE_FILTER,
    arrivalDate,
  };
}

export function guestsManagementGuardSetCountToShowAction(
  count: number
): guestsManagementGuardSetCountToShowActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_COUNT_TO_SHOW,
    count,
  };
}

export function guestsManagementMyGuestsSetCountToShowAction(
  count: number
): guestsManagementMyGuestsSetCountToShowActionType {
  return {
    type: GUESTS_MANAGEMENT_MY_GUESTS_SET_COUNT_TO_SHOW,
    count,
  };
}

export function guestsManagementGuardSetPagesAction(
  pages: number
): guestsManagementGuardSetPagesActionType {
  return {
    type: GUESTS_MANAGEMENT_GUARD_SET_PAGES,
    pages,
  };
}

export function guestsManagementMyGuestsSetPagesAction(
  pages: number
): guestsManagementMyGuestsSetPagesActionType {
  return {
    type: GUESTS_MANAGEMENT_MY_GUESTS_SET_PAGES,
    pages,
  };
}

export function guestsManagementGetAllFutureGuestsAction(
  futureGuests: Guest[]
): guestsManagementGetAllFutureGuestsActionType {
  return {
    type: GUESTS_MANAGEMENT_GET_ALL_FUTURE_GUESTS,
    payload: futureGuests,
  };
}

export function guestsManagementGetAllPastGuestsAction(
  pastGuests: Guest[]
): guestsManagementGetAllPastGuestsActionType {
  return {
    type: GUESTS_MANAGEMENT_GET_ALL_PAST_GUESTS,
    payload: pastGuests,
  };
}

export function guestsManagementGetAllGuardPastGuestsAction(
  guardPastGuests: Guest[]
): guestsManagementGetAllGuardPastGuestsActionType {
  return {
    type: GUESTS_MANAGEMENT_GET_ALL_GUARD_PAST_GUESTS,
    payload: guardPastGuests,
  };
}

export function guestsManagementGetAllGuardFutureGuestsAction(
  guardFutureGuests: Guest[]
): guestsManagementGetAllGuardFutureGuestsActionType {
  return {
    type: GUESTS_MANAGEMENT_GET_ALL_GUARD_FUTURE_GUESTS,
    payload: guardFutureGuests,
  };
}

export function guestsManagementDeleteFutureGuestAction(
  id: number
): guestsManagementRemoveFutureGuestActionType {
  return {
    type: GUESTS_MANAGEMENT_DELETE_FUTURE_GUEST,
    id,
  };
}

export function guestsManagementDeletePastGuestAction(
  id: number
): guestsManagementRemovePastGuestActionType {
  return {
    type: GUESTS_MANAGEMENT_DELETE_PAST_GUEST,
    id,
  };
}

export function guestsManagementMyGuestsSetActivePageAction(
  page: number
): guestsManagementMyGuestsSetActivePageActionType {
  return {
    type: GUESTS_MANAGEMENT_MY_GUESTS_SET_ACTIVE_PAGE,
    page,
  };
}

export function guestsManagementGetAllFutureGuestsByIdThunk(
  count: number,
  page: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const filtersState = getState()[GUESTS_MANAGEMENT_NAMESPACE].guestFilters;

    if (page < 1) {
      page = 1;
    }
    const filtersData = guestsFiltersDto(
      filtersState,
      count,
      (page - 1) * count
    );

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.getAllFutureGuestsByUserId(filtersData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllFutureGuestsAction(
            response.data.guests.sort((a, b) => a.arrivingOn - b.arrivingOn)
          )
        );
        dispatch(
          guestsManagementMyGuestsSetPagesAction(response.data.totalPages)
        );
        dispatch(guestsManagementMyGuestsSetActivePageAction(page));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementGetAllPastGuestsByIdThunk(
  count: number,
  page: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const filtersState = getState()[GUESTS_MANAGEMENT_NAMESPACE].guestFilters;

    if (page < 1) {
      page = 1;
    }

    const filtersData = guestsFiltersDto(
      filtersState,
      count,
      (page - 1) * count
    );

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.getAllPastGuestsByUserId(filtersData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllPastGuestsAction(
            response.data.guests.sort((a, b) => b.arrivingOn - a.arrivingOn)
          )
        );
        dispatch(
          guestsManagementMyGuestsSetPagesAction(response.data.totalPages)
        );
        dispatch(guestsManagementMyGuestsSetActivePageAction(page));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementGetAllGuardFutureGuestsThunk(
  count: number,
  page: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const filtersState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestFilters;

    const filtersData = guardGuestsFiltersDto(
      filtersState,
      count,
      (page - 1) * count
    );

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.getAllGuardFutureGuests(filtersData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllGuardFutureGuestsAction(
            response.data.guests.sort((a, b) => a.arrivingOn - b.arrivingOn)
          )
        );
        dispatch(guestsManagementGuardSetPagesAction(response.data.totalPages));
        dispatch(guestsManagementGuardSetActivePageAction(page));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRefreshAllGuardFutureGuestsThunk(): GuestsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    const paginationState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestPagination;

    return dispatch(
      guestsManagementGetAllGuardFutureGuestsThunk(
        paginationState.countToShow,
        paginationState.activePage
      )
    );
  };
}

export function guestsManagementRefreshAllGuardPastGuestsThunk(): GuestsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    const paginationState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestPagination;

    return dispatch(
      guestsManagementGetAllGuardFutureGuestsThunk(
        paginationState.countToShow,
        paginationState.activePage
      )
    );
  };
}

export function guestsManagementGetAllGuardPastGuestsThunk(
  count: number,
  page: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const filtersState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestFilters;

    const filtersData = guardGuestsFiltersDto(
      filtersState,
      count,
      (page - 1) * count
    );

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.getAllGuardPastGuests(filtersData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllGuardPastGuestsAction(
            response.data.guests.sort((a, b) => b.arrivingOn - a.arrivingOn)
          )
        );
        dispatch(guestsManagementGuardSetPagesAction(response.data.totalPages));
        dispatch(guestsManagementGuardSetActivePageAction(page));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRemoveFutureGuestThunk(
  id: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.removeGuest(id)
      .then((response) => {
        dispatch(guestsManagementDeleteFutureGuestAction(id));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRemoveGuestThunk(
  id: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    return GuestManagementApi.removeGuest(id)
      .then((response) => {
        dispatch(guestsManagementDeleteFutureGuestAction(id));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRemoveGuardFutureGuestThunk(
  id: number,
  callBack: (isSuccessful: boolean, s: string) => void
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const guardGuestPagination =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestPagination;

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.removeGuest(id)
      .then((response) => {
        dispatch(
          guestsManagementGetAllGuardFutureGuestsThunk(
            guardGuestPagination.countToShow,
            guardGuestPagination.activePage
          )
        );
        callBack(true, 'Visitor has been deleted');
      })
      .catch((error) => {
        callBack(false, error.response.data.error?.message);
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRemoveGuardPastGuestThunk(
  id: number,
  callBack: (isSuccessful: boolean, s: string) => void
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const guardGuestPagination =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestPagination;

    const filtersState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestFilters;

    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.removeGuest(id)
      .then((response) => {
        dispatch(
          guestsManagementGetAllGuardPastGuestsThunk(
            guardGuestPagination.countToShow,
            guardGuestPagination.activePage
          )
        );
        callBack(true, 'Visitor has been deleted');
      })
      .catch((error) => {
        callBack(false, error.response.data.error?.message);
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementRemovePastGuestThunk(
  id: number,
  callBack: (isSuccessful: boolean, s: string) => void
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    GuestManagementApi.removeGuest(id)
      .then((response) => {
        dispatch(guestsManagementDeletePastGuestAction(id));
        callBack(true, 'Visitor has been deleted');
      })
      .catch((error) => {
        callBack(false, error.response.data.error?.message);
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementAddGuestThunk(
  guest: InviteVisitorFormValues,
  space: GuestPlaceDto,
  callBack: (isSuccessful: boolean, s: string) => void,
  t: TFunction
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const authState = getState()['AUTH_NAMESPACE'];
    const paginationState = getState()[GUESTS_MANAGEMENT_NAMESPACE].pagination;

    if (!authState.profile.id || !authState.profile.companyId) {
      throw new Error(t('NOT_FOUND_USER_OR_COMPANY'));
    }

    dispatch(startLoaderThunk()).finally();
    const requestData = guestsManagementAddGuestDto(
      guest,
      space,
      authState.profile.id,
      authState.profile.companyId
    );

    return await GuestManagementApi.addNewGuest(requestData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllFutureGuestsByIdThunk(
            paginationState.countToShow,
            paginationState.pages
          )
        );
        callBack(true, t('VISITOR_ADDED_SUCCESSFULLY'));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementAddGuestFromGuardThunk(
  guest: InviteVisitorFormValues,
  space: GuestPlaceDto,
  callBack: (isSuccessful: boolean, s: string) => void,
  t: TFunction
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const authState = getState()['AUTH_NAMESPACE'];
    const guardGuestPagination =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].guardGuestPagination;

    if (!authState.profile.id || !authState.profile.companyId) {
      throw new Error(t('NOT_FOUND_USER_OR_COMPANY'));
    }

    dispatch(startLoaderThunk()).finally();
    const requestData = guestsManagementAddGuestDto(
      guest,
      space,
      authState.profile.id,
      authState.profile.companyId
    );

    GuestManagementApi.addNewGuest(requestData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllGuardFutureGuestsThunk(
            guardGuestPagination.countToShow,
            guardGuestPagination.activePage
          )
        );
        callBack(true, t('VISITOR_ADDED_SUCCESSFULLY'));
      })
      .catch((error) => {
        callBack(false, error.message);
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementEditGuestThunk(
  id: number,
  guest: GuestManagementUpdateGuest,
  space: GuestPlaceDto,
  callBack: (isSuccessful: boolean, s: string) => void,
  t: TFunction
): ResourceManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    const authState = getState()['AUTH_NAMESPACE'];
    const paginationState = getState()[GUESTS_MANAGEMENT_NAMESPACE].pagination;
    const inviterNameData = guest.invitedName || guest.invitedNameFreeText;

    const requestData: UpdateGuestRequestDto = {
      ...guest,
      full_name: guest.fullName,
      phone: guest.phone ? guest.phone : undefined,
      email: guest.email ? guest.email : undefined,
      arriving_on: guest.arrivingOn,
      allow_parking: guest.allowParking,
      license_number:
        guest.licenseNumber && guest.allowParking ? guest.licenseNumber : null,
      user_id: authState.profile?.id ? authState.profile?.id : 1,
      building_id: guest.building,
      company_id: authState.profile?.companyId
        ? authState.profile?.companyId
        : 1,
      parking_number:
        Boolean(guest.parkingNumber) && Boolean(guest.allowParking)
          ? guest.parkingNumber
          : undefined,
      parking_floor_number:
        Boolean(guest.parkingFloorNumber) && Boolean(guest.allowParking)
          ? guest.parkingFloorNumber
          : undefined,
      guest_floors: guest.guestFloors,
      inviter_name: guest.orderForAnother ? inviterNameData : undefined,
      specialNeed: guest.specialNeed,
      place: space,
    };
    GuestManagementApi.updateGuest(id, requestData)
      .then((response) => {
        dispatch(
          guestsManagementGetAllFutureGuestsByIdThunk(
            paginationState.countToShow,
            paginationState.pages
          )
        );
        callBack(true, t('VISITOR_UPDATED_SUCCESSFULLY', { id }));
      })
      .catch((error) => {
        callBack(false, error.response.data.error?.message);
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementFetchGuestByIdThunk(
  id: number
): GuestsManagementThunk<Promise<any>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    return GuestManagementApi.getGuestById(id)
      .then((response) => {
        return response.data;
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementAddManyGuestsFromFileThunk(
  file: any,
  companyId?: number,
  userId?: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    const guestsPagination = getState()[GUESTS_MANAGEMENT_NAMESPACE].pagination;

    const uploadData: CreateManyGuestsRequestDto = {
      companyId,
      userId,
      file,
    };

    return GuestManagementApi.addManyGuestsFromFile(uploadData)
      .then(async (response) => {
        // Fetch the table, no matter what was the response
        await dispatch(guestsManagementGetAllFutureGuestsByIdThunk(10, 1));
        // call the callback with result
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function guestsManagementAddRepeatableGuestThunk(
  guest: AddNewRepeatableGuestRequestDto
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const paginationState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].repeatableGuests.pagination;

    await GuestManagementApi.createRepeatableGuest(guest);
    await dispatch(
      guestsManagementGetAllRepeatableGuestsThunk(
        paginationState.countToShow,
        paginationState.activePage
      )
    );
  };
}

export function guestsManagementUpdateRepeatableGuestThunk(
  id: number,
  guest: UpdateNewRepeatableGuestRequestDto
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const paginationState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].repeatableGuests.pagination;

    await GuestManagementApi.updateRepeatableGuest(id, guest);
    await dispatch(
      guestsManagementGetAllRepeatableGuestsThunk(
        paginationState.countToShow,
        paginationState.activePage
      )
    );
  };
}

export function guestsManagementRemoveRepeatableGuestThunk(
  id: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const paginationState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].repeatableGuests.pagination;

    await GuestManagementApi.removeRepeatableGuest(id);
    await dispatch(
      guestsManagementGetAllRepeatableGuestsThunk(
        paginationState.countToShow,
        paginationState.activePage
      )
    );
  };
}

export function guestsManagementGetAllRepeatableGuestsThunk(
  count: number,
  page: number
): GuestsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    const filtersState =
      getState()[GUESTS_MANAGEMENT_NAMESPACE].repeatableGuests.filters;

    if (page < 1) {
      page = 1;
    }

    const response = await GuestManagementApi.getRepeatableGuestsByQuery({
      full_name: filtersState.fullName,
      take: count,
      skip: (page - 1) * count,
    });
    const data = response.data;

    dispatch(guestsManagementSetRepeatableGuestsAction(data.guests));
    dispatch(
      guestsManagementRepeatableGuestsSetPagesAction(response.data.totalPages)
    );
    dispatch(guestsManagementRepeatableGuestsSetActivePageAction(page));
  };
}
